export default __webpack_public_path__ + "static/media/pokeball.aaa5c38d.svg";